<template>
  <div class="border mt-5">
    <h4>{{ "cancel_order" | setText("Отменить заказ") }}</h4>
    <h5 class="text-danger">
      {{
        "cancel_order_do"
          | setText(
            "Если у вас поздникли проблемы с заказом. Отмените и начните заново"
          )
      }}
    </h5>
    <div>
      <informator
        title="Причина отмены заказа"
        titleKey="reason_cancel_order"
        v-model="data.client_reject_reason"
        :partner="partner"
        link="get-client-reject-reasons"
      />
    </div>

    <button
      v-if="data.client_reject_reason"
      @click="send"
      class="btn btn-danger"
    >
      {{ "cancel_order" | setText("Отменить заказ") }}
    </button>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  watch: {},
  components: {
    informator: () => import("./Informator"),
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {},
  methods: {
    send() {
      this.$loading(true);
      let data = {
        loan_id: this.transaction.exchange_id,
        client_reject_reason_id: this.data.client_reject_reason.guid,
      };
      this.$http;
      this.$http({
        url: `${this.partner["endpoint_url"]}cancel-loan`,
        method: "POST",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
          "agent-id": this.partner["api_public_key"],
        },
        data: data,
      })
        .then((response) => {
          if (response.data) {
            this.createTransaction({
              step: null,
              status: -1,
              client_confirmed: 0,
              system_confirmed: 0,
            });

            this.$emit("setStep", null);
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      data: {
        client_reject_reason: null,
      },
    };
  },
};
</script>

